import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../api/client';
import { usePermissions } from '../PermissionsContext';

const TABS = [
    { page: 'admin-users', label: 'Users', href: '/admin/users' },
    { page: 'admin-users', label: 'Requests', href: '/admin/requests', badge: true },
    { page: 'admin-roles', label: 'Roles & Permissions', href: '/admin/roles' },
    { page: 'admin-audit', label: 'Audit Log', href: '/admin/audit' },
];

// Общие вкладки административных страниц; видны только доступные разделы.
// На Requests — счётчик ожидающих заявок.
function AdminTabs() {
    const { can } = usePermissions();
    const { pathname } = useLocation();
    const [pending, setPending] = useState(0);

    useEffect(() => {
        if (!can('admin-users')) return;
        api.get('/api/admin/access-requests/count')
            .then(r => setPending(r.data.pending))
            .catch(() => {}); // бейдж не критичен
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="admin-tabs">
            {TABS.filter(t => can(t.page)).map(t => (
                <a key={t.href} href={t.href}
                    className={`admin-tabs__link${pathname === t.href ? ' is-active' : ''}`}>
                    {t.label}
                    {t.badge && pending > 0 && <span className="admin-tabs__badge">{pending}</span>}
                </a>
            ))}
        </div>
    );
}

export default AdminTabs;
